import LoginPerson from "./LoginPerson";
export default LoginPerson;